// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimValueSummary from '../../shared/components/claim-value-summary/';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerPanel from '../../../shared/components/customer-panel/customer-panel';
import FileAttachmentPanel from '../../../shared/components/file-attachment-panel';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import PartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-part';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductPanel from '../../shared/components/product-panel';
import {getTempAttachmentServiceConfig} from '../../shared/services/claim-shared-helper';

function handleFileDelete(file) {

    this.onFileDelete(file);

}

function handleFileUploadSuccess(file, dropzone) {

    this.onFileUploadSuccess(file, dropzone);

}

const PartsClaimAside = props =>
    <aside>
        {!props.claim.lifeTime && !props.claim.merchandizeItem &&
            <section>
                <ProductPanel
                    baseMachineCode={props.product.baseMachineCode}
                    buildDate={props.product.buildDate}
                    handleWarrantyLink={props.handleWarrantyLink}
                    imageUrl={props.product.imageUrl}
                    latestPerUnitMeasurements={props.latestPerUnitMeasurements}
                    modelNumber={props.product.model}
                    pin={props.product.pin}
                    pipIndicator={props.product.pipIndicator}
                    updatedDate={props.product.useAmountLastUpdated}
                    useAmount={props.product.useAmount}
                />
                <CustomerPanel
                    customer={props.customer}
                    isCkcCustomerFailed={props.isCkcCustomerFailed}
                    product={props.product}
                />
            </section>
        }
        {props.claim.reimbursementDetails.totalApproved > 0 &&
            <ClaimValueSummary
                allowedActions={props.claim.allowedActions}
                claimNumber={props.claim.claimNumber}
                claimStatus={props.claim.claimStatus.key}
                claimValueDetails={props.claim.claimValueDetails}
                className='claim-value-summary'
                reimbursementDetails={props.claim.reimbursementDetails}
            />
        }
        <FileAttachmentPanel
            files={props.claim.file}
            onFileDelete={props::handleFileDelete}
            onFileUploadSuccess={props::handleFileUploadSuccess}
            serviceConfig={getTempAttachmentServiceConfig(props.claim.claimNumber, props.temporaryObjectKey)}
        />
    </aside>;

PartsClaimAside.displayName = 'PartsClaimAside';
PartsClaimAside.propTypes = {
    claim: PropTypes.instanceOf(PartsClaim).isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    handleWarrantyLink: PropTypes.func.isRequired,
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    latestPerUnitMeasurements: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUploadSuccess: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    temporaryObjectKey: PropTypes.string

};

export default PartsClaimAside;



// WEBPACK FOOTER //
// ./src/claim/parts/components/parts-claim-aside.js